import { useRef } from 'react';
import { createContainer } from 'unstated-next';

import { SelectOptionType } from '../types';

function useSelectState() {
  const cacheRef = useRef<Map<string, SelectOptionType>>(new Map());

  return {
    cacheRef,
  };
}

export default createContainer(useSelectState);
